import React, { useContext } from "react";
import FinalFormModal from "../../General/FinalFormModal/FinalFormModal";
import { UsersContext } from "../../../Utils/contexts/UsersContext";
import { demoteUser } from "../../../Utils/functions/api/usersApi";
import ApiError from "../../../Utils/error/ApiError";
import { useSnackbar } from "notistack";

const DemoteUserModal = ({ user, indentifyer = "DemoteUserModal" }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { users, setUsers } = useContext(UsersContext);

  const closeModal = () => {
    document.getElementById(indentifyer).M_Modal.close();
  };

  const submitDemoteUserForm = async (user) => {
    try {
      const res = await demoteUser(user);
      createNotification(`"${user}" är inte längre SuperUser.`,"success");
      let newUsers = JSON.parse(JSON.stringify(users));
      newUsers.find((x) => x.username === user).isSuperUser = false;
      setUsers(newUsers);
      closeModal();
    } catch (err) {
      createNotification(`Kunde inte degradera "${user}".`,"error");
      closeModal();
    }
  };

  const createNotification = (text, variant) => {
    enqueueSnackbar(`${text}`, {variant});
  };

  return (
    <FinalFormModal
      modalHTMLIdentifier={indentifyer}
      inputFields={[]}
      initialValues={[]}
      onClick={(e) => e.stopPropagation()}
      onSubmit={() => submitDemoteUserForm(user)}
      submitButtonName={"Ja"}
      cancelButtonName={"Nej"}
      formInfo={{
        header: `Vill du göra användaren ${user} till konsult?`,
      }}
      errorMessage=""
    />
  );
};

export default DemoteUserModal;
